module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/rss-ff1d96ec7bb8fb9d5f638e33df9e78b2.svg";